import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsRuleChange implements ICommand
{

	public GameType : number = 0;
	public RuleIndex : number = 0;
	public HostID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.GameType = ba.readInt53();
		this.RuleIndex = ba.readInt53();
		this.HostID = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.GameType);
		ba.writeUint53(this.RuleIndex);
		ba.writeUint16(this.HostID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsRuleChange();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'GameType(Q)='+this.GameType+' ';
		str += 'RuleIndex(Q)='+this.RuleIndex+' ';
		str += 'HostID(W)='+this.HostID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55003;
	}

	public getCmdName() : string
	{
		return 'PsRuleChange';
	}

}
